// extracted by mini-css-extract-plugin
module.exports = {"offerPage":"offerPage_offerPage__10UYu","offerBody":"offerPage_offerBody__2AS5y","plant":"offerPage_plant__2SsNq"};